import { SelectOptionsType } from '../types/ApprovalSettings'

export const emptyApprovalSettings = {
    uid: '',
    reportId: '',
    reportName: '',
    isReportDraft: false,
    scheduleId: '',
    scheduleName: '',
    recipientGroupId: [],
    alertRuleId: '',
    alertRuleName: '',
    isScheduleActive: false,
    assets: [],
    timespan: '',
    frequency: '',
    hour: '',
    isApprovalSettingsDraft: false,
    isApprovalSettingsValid: false
}

export const timespanOptions: SelectOptionsType[] = [
    { value: '12 hours', label: '12 hours' },
    { value: '24 hours', label: '24 hours' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
    { value: 'year', label: 'Year' }
]

export const frequencyOptions: SelectOptionsType[] = [
    { value: 'every 12 hours', label: 'Every 12 hours' },
    { value: 'every 24 hours', label: 'Every 24 hours' },
    { value: 'every 48 hours', label: 'Every 48 hours' },
    { value: 'every week', label: 'Every Week' },
    { value: 'every month', label: 'Every Month' },
    { value: 'every year', label: 'Every Year' }
]
